
export const packages = [
  "@openimis/fe-core",
  "@openimis/fe-home",
  "@openimis/fe-location",
  "@openimis/fe-admin",
  "@openimis/fe-profile",
  "@openimis/fe-grievance_social_protection",
  "@openimis/fe-language_fr",
  "@openimis/fe-workforce",
  "@openimis/fe-biometric_verification"
];


export function loadModules(cfg = {}) {
  const loadedModules = [];

  try {
    loadedModules.push(require("@openimis/fe-core").CoreModule(cfg["fe-core"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-core". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-home").HomeModule(cfg["fe-home"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-home". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-location").LocationModule(cfg["fe-location"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-location". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-admin").AdminModule(cfg["fe-admin"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-admin". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-profile").ProfileModule(cfg["fe-profile"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-profile". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  //try {
    //loadedModules.push(require("@openimis/fe-grievance_social_protection").GrievanceSocialProtectionModule(cfg["fe-grievance_social_protection"] || {}));
  //} catch (error) {
    //alert(`Failed to load module "@openimis/fe-grievance_social_protection". More details can be found in the developer console. Look for: ${error}`);
  //  console.error(error);
//  }

  try {
    loadedModules.push(require("@openimis/fe-language_fr").LanguageFrModule(cfg["fe-language_fr"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-language_fr". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-workforce").WorkforceModule(cfg["fe-workforce"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-workforce". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  
  try {
    loadedModules.push(require("@openimis/fe-biometric_verification").BiometricVerificationModule(cfg["fe-biometric_verification"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-biometric_verification". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  return loadedModules;
}

